import { deleteProvince, editProvince, createProvince } from "../../api/state/modal.js";
import { Delete } from "@mui/icons-material";
import { Box, Button, CircularProgress, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, TextInput } from "../../../../shared/ui/common/index.js";

import Confirm from "../../../../shared/ui/modals/Confirm.jsx";


import { logout } from "../../../../shared/state/slices/user.js";
const StateModal = ({
  open,
  close,
  data = {},
  forEdit,
  setAllRows,
  allRows,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.user);

  const [searchParams, setSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [prevData, setPrevData] = useState({});
  const [openDelete, setOpenDelete] = useState(false);

  // set data
  useEffect(() => {
    if (forEdit) {
      setPrevData({
        ...data,
        parentId: allRows.find((cat) => cat.id === data.parentId),
      });
    } else {
      resetData();
    }
  }, [allRows, data, forEdit]);
  const resetData = () => {
    setPrevData(data);
  };
  const deleteCategory = () => {
    if (data) {
      setLoading(true);
      deleteProvince(data, token)
        .then((res) => {
          setLoading(false);
          setOpenDelete(false);
          var temp = [...allRows];
          var newData = temp.filter((item) => item.id !== data.id);
          setAllRows(newData);
          close();
          toast.success("با موفقیت حذف شد");
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.response?.data?.message);
          setOpenDelete(false);
          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    }
  };

  const editItem = () => {
    var temp = [...allRows];
    if (prevData?.title) {
      setLoading(true);
      if (forEdit) {
        editProvince(prevData, searchParams, token)
          .then((res) => {
            setLoading(false);
            toast.success("با موفقیت ویرایش شد");
            var index = temp.findIndex((item) => item.id === data.id);
            temp[index] = res.data.data;
            setAllRows(temp);
            close();
            resetData();
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err.response?.data?.message);

            if (err.response.status === 401) {
              dispatch(logout());
            }
          });
      } else {
        createProvince(prevData, searchParams, token)
          .then((res) => {
            temp.unshift(res.data.data);

            setAllRows(temp);
            setLoading(false);
            toast.success("با موفقیت اضافه شد");
            close();
            resetData();
          })
          .catch((err) => {
            setLoading(false);
            toast.error(err.response?.data?.message);

            if (err.response.status === 401) {
              dispatch(logout());
            }
          });
      }
    } else if (!prevData?.title) {
      toast.error("نام  کشور را وارد کنید");
    }
  };

  return (
    <Modal
      open={open}
      close={close}
      title={` ${forEdit ? "ویرایش" : "افزودن"}   استان 
    `}
    >
      <TextInput
        label="نام   استان"
        change={(e) => setPrevData({ ...prevData, title: e })}
        currentValue={prevData?.title}
      />

      <Box sx={{ display: "flex" }}>
        {forEdit && (
          <IconButton onClick={() => setOpenDelete(true)}>
            <Delete color="error" />
          </IconButton>
        )}
        <div style={{ flexGrow: 1 }} />
        <Button
          variant="contained"
          color="primary"
          onClick={editItem}
          disabled={loading}
        >
          {loading ? <CircularProgress /> : <>ثبت اطلاعات</>}
        </Button>
      </Box>
      <Confirm
        message="آیا از حذف این  استان اطمینان دارید؟"
        close={() => setOpenDelete(false)}
        submit={deleteCategory}
        open={openDelete}
      />
    </Modal>
  );
};

export default StateModal;
